import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { ApsFileBrowser } from "./ApsFileBrowser";

interface ApsFileBrowserModalProps {
  open: boolean;
  onClose: () => void;
  onFileSelect: (urn: string) => void;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'rgba(20, 20, 20, 0.8)', // Dark translucent background
  backdropFilter: 'blur(10px)', // Blur effect
  border: '1px solid rgba(255, 255, 255, 0.1)', // Subtle border
  boxShadow: 24,
  borderRadius: '16px', // Rounded corners
  p: 4,
  color: '#ffffff' // White text color
};

export const ApsFileBrowserModal: React.FC<ApsFileBrowserModalProps> = ({ open, onClose, onFileSelect }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="aps-file-browser-modal-title"
      aria-describedby="aps-file-browser-modal-description"
    >
      <Box sx={style}>
        <Typography id="aps-file-browser-modal-title" variant="h6" component="h2">
          Select a File from APS
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#ffffff',
          }}
        >
          <CloseIcon />
        </IconButton>
        <ApsFileBrowser 
          onUrnExtracted={(urn, encodedUrn, item) => {
            onFileSelect(urn);
            onClose();
          }}
        />
      </Box>
    </Modal>
  );
};
